import * as models from '@daas-consulting/production/remitos/frontend/models';
import { Observable } from 'rxjs';

export interface RemitosPrintPageViewContract {
  printData$: Observable<models.print.PrintDataView | null>;
  printSuccessful$: Observable<void>;
  loadPrintData(remitoId: string): void;
  print(remitoId: string): void;
}

export const RemitosPrintPageViewContractId = 'RemitosPrintPageViewContractId';
